<template>
  <div class="card__box--div">
    <a-row type="flex" justify="space-between" :gutter="24">
      <a-col :span="6" v-for="(item,index) in cardOptions" :key="index">
        <a-card :headStyle="headStyle" class="productCard" :bordered="false">
          <template slot="title">
            <span class="title__span">{{item.title}}</span>
          </template>
          <span slot="extra" class="extra__span">{{item.cost}}</span>
          <p class="card__text--p" v-for="(text,textIndex) in item.contentArr" :key="textIndex">
            {{text}}
          </p>
          <a-button type="default" class="card__btn" @click="buy(index)">马上使用</a-button>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      title="请选择支付方式"
      v-model="visible"
      :footer="false"
    >
      <div class="btn-group">
        <a-button type="primary" icon="wechat" @click="payInterface('wx')">微信</a-button>
        <a-button type="primary" icon="alipay-circle" @click="payInterface('zfb')">支付宝</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import payApi from "@/request/api-manager/pay.js";
import orderApi from "@/request/api-manager/order.js";

import Vue from "vue";
import { TOKEN, USER_ID, USER_NAME } from "@/store/mutation-types";

export default {
  name:'ProductCard',
  props:{
    options:{
      type:Array
    }
  },
  watch:{
    options(val){
      console.log(val,"val")
      this.cardOptions = val
    }
  },
  created(){
    this.cardOptions = this.options
  },
  data(){
    return {
      headStyle:{
        textAlign:'left',
        background: '#FBF4EF',
        borderBottom:'none'
      },
      cardOptions:[],
      visible: false,
      currentOrder: 0
    }
  },
  methods: {
    buy(index) {
      if ( index > 3 ) {
        this.$router.push({
          path:'/buy/index'
        })
      } else {
        this.visible = true
        // this.payInterface(index)
        this.currentOrder = index
      }
      
    },
    payInterface(payWay) {
      console.log(this.currentOrder,'this.currentOrder');
      this.payWay = payWay
      const { price, title } = this.cardOptions[this.currentOrder]
      
      let params = {
        sysUserId: Vue.ls.get(USER_ID),
        status: 0,
        productName: title,
        discount: 0,
        productPrice: price,
        payPrice: price,
      };
      console.log(params,'params');
      this.sendGenerateOrder(params);
    },
    sendGenerateOrder(params) {
      let self = this;

      orderApi.add(params).then((res) => {
        if (res.code !== 200) {
          return console.log(res.message);
        }
        console.log(res);

        let data = {
          order_id: res.result.id,
          total_amount: res.result.payPrice,
          product_name: res.result.productName,
          product_description: self.cardOptions[self.currentOrder].contentArr[0]
        };

        if (self.payWay === "wx") {
          data.total_amount = parseFloat(data.total_amount * 100).toFixed();
          self.sendWechatPayment(data);
        }

        if (self.payWay === "zfb") {
          self.sendAlipayPayment(data);
        }
      });
    },
    /**
     * 发送微信支付请求
     */
    sendWechatPayment(params) {
      payApi.wxPay(params).then((res) => {
        if (res.code > 0) {
          console.error("请求错误");
          return;
        }

        console.log(res);
        this.$router.push({
          path: "/WeChat-pay/index",
          query: { url: res.data },
        });
      });
    },
    /**
     * 发送支付宝支付请求
     */
    sendAlipayPayment(params) {
      const newTab = window.open();
      payApi.aliPay(params).then((res) => {
        console.log(res);
        const div = document.createElement("div");
        div.innerHTML = res; // html code
        newTab.document.body.appendChild(div);
        newTab.document.forms.punchout_form.submit();
      });
    },
  }
}
</script>
<style lang="less" scoped>
@import '../index.less';
</style>